import React from 'react';
import { Box, Typography } from '@mui/material';

function GeneralTableWidget({ widget, data, theme }) {
  const isDark = theme === 'dark';
  const liveData = Array.isArray(data) ? data : [];
  const tagprops = widget?.props?.extended?.tagprops || [];

  const rows = tagprops.map((tp) => {
    const match = liveData.find((d) => String(d.TagId) === String(tp.tagId));
    return { name: tp.alias || tp.tagId, value: match?.value ?? '—', unit: tp.unit || '', tagId: tp.tagId };
  });

  const dataRows = rows.length > 0 ? rows : [{ name: '—', value: '—', unit: '', tagId: '__empty__' }];
  const hdr = isDark ? '#aaa' : '#555';
  const border = `1px solid ${isDark ? '#333' : '#eee'}`;

  return (
    <Box sx={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', px: 0.75, py: 0.25 }}>
      <Box sx={{ display: 'flex', flexShrink: 0, pb: 0.5, borderBottom: border, gap: 0.5 }}>
        <Typography variant="caption" sx={{ flex: '1 1 40%', fontWeight: 700, color: hdr, fontSize: 11 }}>Tag</Typography>
        <Typography variant="caption" sx={{ flex: '1 1 30%', fontWeight: 700, color: hdr, fontSize: 11 }}>Value</Typography>
        <Typography variant="caption" sx={{ flex: '1 1 28%', fontWeight: 700, color: hdr, fontSize: 11 }}>Unit</Typography>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', overflow: 'hidden' }}>
        {dataRows.map((r) => (
          <Box key={r.tagId} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: '1 1 0', minHeight: 0, borderBottom: border, py: 0.25 }}>
            <Typography variant="body2" sx={{ flex: '1 1 40%', color: isDark ? '#ccc' : '#333', fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.name}</Typography>
            <Typography variant="body2" sx={{ flex: '1 1 30%', color: isDark ? '#fff' : '#000', fontWeight: 700, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.value}</Typography>
            <Typography variant="body2" sx={{ flex: '1 1 28%', color: isDark ? '#aaa' : '#666', fontSize: 11 }}>{r.unit}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default React.memo(GeneralTableWidget);
